module.exports = __webpack_public_path__ + "img/bg2@2x.60c6f24f.png";